import { render, staticRenderFns } from "./practitioner-locations.vue?vue&type=template&id=70f0bab8&"
import script from "./practitioner-locations.vue?vue&type=script&lang=ts&"
export * from "./practitioner-locations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports